import { useTranslation } from 'react-i18next';

interface PasswordStrengthBarProps {
  strength: number;
}

const PasswordStrengthBar = ({ strength }: PasswordStrengthBarProps) => {
  const { t } = useTranslation();
  const getColor = () => {
    if (strength < 40) return 'bg-red-500';
    if (strength < 60) return 'bg-yellow-500';
    if (strength < 80) return 'bg-blue-500';
    return 'bg-green-500';
  };

  const getLabel = () => {
    if (strength < 40) return t('auth.passwordStrength.weak');
    if (strength < 60) return t('auth.passwordStrength.fair');
    if (strength < 80) return t('auth.passwordStrength.good');
    return t('auth.passwordStrength.strong');
  };

  return (
    <div className="mt-2">
      <div className="flex justify-between mb-1">
        <span className="text-sm text-gray-600">{t('auth.passwordStrength.label')}:</span>
        <span className={`text-sm font-medium ${getColor().replace('bg-', 'text-')}`}>
          {getLabel()}
        </span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full">
        <div
          className={`h-full rounded-full transition-all duration-300 ${getColor()}`}
          style={{ width: `${strength}%` }}
        />
      </div>
    </div>
  );
};

export default PasswordStrengthBar; 